import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import CenteredToast from '../centeredToast/centeredToast';
import { clearSession, setQrCode } from '../../redux/slice/sessionSlice';
import { useCancelSessionMutation, useModifyComponentsMutation } from '../../redux/services/sessionApi';
import { setProfileMeta } from '../../redux/slice/tanProfileSlice';
import { CacheExpiration } from 'workbox-expiration';
import { fullResetProfile } from '../../redux/slice/tanProfileSlice';
import { clearPayments } from '../../redux/slice/paymentSlice';
import { defaultSerializeQueryArgs } from '@reduxjs/toolkit/query';
import { slice_map } from '../../components/componentMap/componentMap';

const StateManager = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [toastVisible, setToastVisible] = useState(false);
  const [cancelSession, { isLoading: doingACancel, isSuccess: canceled, isError: didNotCancel }] = useCancelSessionMutation();
  const session = useSelector((state) => state?.session?.session);
  const confirmedSession = useSelector((state) => state?.session?.confirmedSession);
  const sessionSendCompleted = useSelector((state) => state?.session?.sessionSendCompleted);
  const qrCode = useSelector((state) => state?.session?.qrCode)
  const tanProfile = useSelector((state) => state?.tanProfile)
  const [modifyComponents, {  }] = useModifyComponentsMutation(); 
  const sessionTimer = useRef(null)
  console.log(tanProfile)
  const runCancel = (navigateLocation) => {
    dispatch(setQrCode({
      uid: null,
      timeStamp: null
    }))
    dispatch(clearSession())
    dispatch(fullResetProfile())
    dispatch(clearPayments())
    if (session?.sid && session?.uid) {
      cancelSession({
        uid: session?.uid,
        sid: session?.sid,
      }).unwrap()
        .then((result) => {
          if (navigateLocation) {
            navigate(navigateLocation)
          }
          clearInterval(sessionTimer.current);
        })
        .catch((err) => {
          console.log(err)
          if (navigateLocation) {
            navigate(navigateLocation)
          }
          clearInterval(sessionTimer.current);
        })
    }
    if(confirmedSession){
      // modifyComponents([]).unwrap()
    }
  }

  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();
    let canHaveSession = currentPath.startsWith('/session') || currentPath.startsWith('/scanlanding') || currentPath.startsWith('/addpaymentmethod') || currentPath.startsWith('/login')
    if(!sessionSendCompleted){ //completed session
      if (!sessionTimer.current && session?.expire_time) {
        let timeout = new Date(session.expire_time).getTime() - new Date(session.issue_time)
        // timeout = 1000
        sessionTimer.current = setTimeout(() => {
          setToastVisible("expiredSession")
        }, timeout)
        // console.log(session)
      }
      if (!canHaveSession && session) {
        setToastVisible("existingSession");
      } else {
        setToastVisible(false);
      }
    }else{
      runCancel()
    }
    
  }, [location, session]);
  useEffect(() => {
    if(session?.expire_time){
      let timeout = new Date(session.expire_time).getTime() - new Date(session.issue_time)
      // timeout = 1000
      if(new Date().getTime() - timeout > qrCode.timeStamp ){
        setToastVisible("expiredSession")
      }
    }
    return () => {
      clearInterval(sessionTimer.current);
    };
  }, [])

  const returnToast = () => {
    switch (toastVisible) {
      case "existingSession":
        return (<CenteredToast
          show={true}
          hideCloseButton={true}
          title={"Active session"}
          body={""}
          acceptButtonText={"Session selection"}
          onAccept={() => {
            if(tanProfile?.scannedBoothData){
              dispatch(setProfileMeta({ profileType: "scanBooth", navigationDirection: 'sessionSelection', options: slice_map(tanProfile?.mappedComponents, tanProfile?.setScannedBoothData?.last_booth_state?.inventory) }))            
            }
            navigate('/session/profileSelection')
          }}
          cancelButtonText={"Cancel session"}
          onCancel={() => runCancel()}
        >{'A session is currently active. Would you like to navigate back to session selection or cancel the session?'}</CenteredToast>)
      case "expiredSession":
        return (<CenteredToast
          show={true}
          hideCloseButton={true}
          title={"Session expired"}
          body={""}
          acceptButtonText={"Start over"}
          onAccept={() => {
            runCancel('/scanner')
          }}
          cancelButtonText={"Cancel"}
          onCancel={() => runCancel("/greeting")}
        >{'Your session has expired! Would you like to start a new one?'}</CenteredToast>)
      default:
        return null
    }
  }
  return (
    <>
      {
        returnToast()
      }</>
  );
};

export default StateManager;
